export default __webpack_public_path__ + "static/media/portadavideoseguimiento3.e9b663b4.png";